import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { calculateOverallTopicAccuracy } from '../../../lib/legacy/legacyEngine'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import CustomProgressBar from '../../../../shared/components/CustomProgressBar'
import progressBarStyle from 'Styles/progress-bar.css'

import TopicPerformanceSummary from '../TopicPerformanceSummary'

import StudyPlanItem from '../../StudyPlanItem'
import FooterBar from '../../FooterBar'

import { creators as actionCreators } from '../../../actions'
import actionProptypes from '../../../actions/proptypes'

import base from 'Styles/base.css'
import panelStyle from 'Styles/panel.css'
import style from './studentDetail.css'

import closeIcon from 'Assets/x-icon-gray.svg'

class StudentDetail extends Component {
  renderTopics () {
    return this.props.activity.allTopics.map((topic) => {
      const isActive = _.some(this.props.activity.topics, (activeTopic) => {
        return topic.label === activeTopic.label
      })

      let totalPointsAvailable = topic.class_points_available * 1
      let totalPointsEarned = topic.class_points_earned * 1

      if (this.props.selectedStudent) {
        totalPointsAvailable = topic.pa_arr[this.props.selectedStudent.index] * 1
        totalPointsEarned = topic.pe_arr[this.props.selectedStudent.index] * 1
      }

      totalPointsAvailable = isFinite(totalPointsAvailable) && totalPointsAvailable > 0
        ? totalPointsAvailable
        : 0

      totalPointsEarned = isFinite(totalPointsEarned) && totalPointsEarned > 0
        ? totalPointsEarned
        : 0

      const hasQuestions = topic.totalQuestions > 0

      return (
        <StudyPlanItem
          key={topic.label}
          label={topic.label}
          totalPointsAvailable={totalPointsAvailable}
          totalPointsEarned={totalPointsEarned}
          hasQuestions={hasQuestions}
          studyPlan={topic.studyPlan}
          disableLinks={this.props.activity.config.disableLinks}
          startedStudents={this.props.activity.studentData.started_students}
          isActive={isActive}
        />
      )
    })
  }

  render () {
    window.scrollTo(0, 0)
    const selectedStudentIndex = this.props.selectedStudent ? this.props.selectedStudent.index : -1
    const overallQuestionAccuracy = calculateOverallTopicAccuracy(this.props.activity.topics, selectedStudentIndex)

    return (

      <div className={style.container}>
        <div className={style.innerContent}>
          <div className={style.studyPlanHeaderContainer}>
            <div tabIndex="0" className={style.pageTitle}>
              Results for:
              <button
                data-test-id="closeStudentDetailBtn"
                aria-label="Close student detail"
                className={classnames(style.hideDetail)}
                onClick={this.props.onBackClick}
                tabIndex="0"
              >
                <object
                  tabIndex="-1"
                  data={closeIcon} type="image/svg+xml"
                  className={base.svgIcon}
                />
              </button>
            </div>
            <h2 className={style.studentNameTitle}>{this.props.selectedStudent.name}</h2>
          </div>
          <div
            className={classnames(panelStyle.base, style.progressContainer)}
            tabIndex="0"
          >
            <h2 className={style.targetScoreHeader}>
              Target Score Progress
            </h2>
            <h3 className={style.scoreValueContainer}>
              <span className={style.scoreValueContainer}>
                <span className={style.scoreValue}>{this.props.selectedStudent.score}</span>
                <span className={style.scoreLabel}> pts</span>
              </span>
            </h3>
            <CustomProgressBar
              dataTestId="studentDetailProgressBar"
              now={this.props.selectedStudent.score}
              min={0}
              max={this.props.activity.score.scoreTarget}
              ariaLabel={`You have ${this.props.selectedStudent.score} points.`}
              progressBarStyle={progressBarStyle}
              style={style}
              className={classnames(progressBarStyle.base, style.progressBar)}
              bsClass={classnames(progressBarStyle.progressValueBase, style.progressBarValue)}
            />

            <Row>
              <Col xs={7} />
              <Col xs={5} className={style.targetCol}>
                <span className={style.scoreLabel}>Target<br /></span>
                <span className={style.scoreValue}>{this.props.activity.score.scoreTarget}</span>
              </Col>
            </Row>
          </div>

          <TopicPerformanceSummary
            topicCount={this.props.activity.topics.length}
            onEditTopicsClick={() => {}}
            questionAccuracy={overallQuestionAccuracy}
            questionsReceived={this.props.selectedStudent.questionsReceived}
            startedStudents={this.props.activity.studentData.started_students}
            individualStudentSelected={true}
            mobile={true}
            onShowAllStudents={() => this.onSelectStudent(null)}
            browser={this.props.browser}
          />
          <div tabIndex="0" className={panelStyle.base}>
            <p className={style.accuracyLabel}>Accuracy</p>
            <h2 className={style.studyPlanHeader}>Topic Performance Details</h2>
          </div>
          {this.renderTopics()}
        </div>

        <FooterBar className={style.instructorFooter}>
          <button
            className={classnames('btn-cdl-main', style.footerButton)}
            onClick={this.props.onBackClick}
          >
            Back to topics & scores
          </button>
        </FooterBar>

      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const scoreTarget = state.core.activity ? state.core.activity.score.scoreTarget : 0
  const students = state.core.activity ? state.core.activity.students : []

  return {
    activity: state.core.activity,
    scoreTarget,
    students
  }
}

StudentDetail.propTypes = {
  activity: PropTypes.object,
  selectedStudent: PropTypes.object,
  scoreTarget: PropTypes.number,
  actions: actionProptypes,
  onBackClick: PropTypes.func.isRequired,
  browser: PropTypes.object.isRequired
}

function mapDispatchToProps (dispatch, ownProps) {
  return { actions: bindActionCreators(actionCreators, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDetail)
